import { useState } from 'react';
import { useConnections } from '../../hooks/useConnections';
import { HarvestConnection } from './HarvestConnection';
import { SharePointConnection } from './SharePointConnection';
import { AIConnection } from './AIConnection';
import { 
  ArrowPathIcon, 
  CheckCircleIcon, 
  ExclamationTriangleIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';

export function ConnectionsManager() {
  const { connections, loading, reload, getConnectionByType } = useConnections();
  
  const harvestConnection = getConnectionByType('harvest');
  const sharepointConnection = getConnectionByType('sharepoint');
  const aiConnection = getConnectionByType('ai');
  
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <CheckCircleIcon className="w-4 h-4 mr-1" />
            Connected
          </span>
        );
      case 'error':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            <ExclamationTriangleIcon className="w-4 h-4 mr-1" />
            Error
          </span>
        );
      case 'pending_auth':
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            <ClockIcon className="w-4 h-4 mr-1" />
            Pending
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            Disconnected
          </span>
        );
    }
  };
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Connections</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage integrations with external services
        </p>
      </div>
      
      <div className="space-y-6">
        {/* Harvest Connection */}
        <HarvestConnection 
          connection={harvestConnection} 
          onUpdate={reload}
        />
        
        {/* SharePoint Connection */}
        <SharePointConnection 
          connection={sharepointConnection} 
          onUpdate={reload}
        />
        
        {/* AI Connection */}
        <AIConnection 
          connection={aiConnection} 
          onUpdate={reload}
        />
      </div>
    </div>
  );
}

